import { render, staticRenderFns } from "./TabPrognose.vue?vue&type=template&id=6144afc7"
import script from "./TabPrognose.vue?vue&type=script&lang=js"
export * from "./TabPrognose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports